module.exports = __webpack_public_path__ + "static/media/ppt.ba6d9244.svg";